export const useCategoryPostsThumbnails = (
  pCategory: CategorySchema | Ref<CategorySchema>,
  pMedias: Map<string, MediaSchema> | Ref<Map<string, MediaSchema>>
): Ref<Thumbnail[]> => {
  const thumbnails = ref<Thumbnail[]>([]);

  const getThumbnais = () => {
    const category = toValue(pCategory);
    const mMedias = toValue(pMedias);

    const route = useRoute();
    const posts = category.posts;

    const thumbnails: Thumbnail[] = posts.map((post, index) => {
      const mediaId = post.medias[0].id;
      // TODO if no mMedias remove items or make request to index db
      const mediaObject = mMedias.get(mediaId);
      const to = `${route.path}#/modal/${category.slug}/${post.slug}`;
      return {
        title: post.title,
        imgSrc: mediaObject.appThumbnailUrl,
        to,
        // id: post.id,
        contentId: post.id,
      };
    });
    return thumbnails;
  };

  watchEffect(() => {
    thumbnails.value = getThumbnais();
  });

  return thumbnails;
};
